import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en";
import ru from "./ru";
import p2 from "./p2";
import p3 from "./p3";
import p4 from "./p4";
import p5 from "./p5";
import p6 from "./p6";
import p7 from "./p7";
import p8 from "./p8";
import p9 from "./p9";
import p10 from "./p10";
import p11 from "./p11";
import p12 from "./p12";
import p13 from "./p13";
import p14 from "./p14";
import p15 from "./p15";
import p16 from "./p16";

const merge = (a, b) => Object.fromEntries([...new Set([...Object.keys(a), ...Object.keys(b)])].map((k) => [k, typeof a[k] === "object" && typeof b[k] === "object" ? { ...a[k], ...b[k] } : b[k] ?? a[k]]));

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: merge(merge(merge(merge(merge(merge(merge(merge(merge(merge(merge(merge(merge(merge(merge(en, p2.en), p3.en), p4.en), p5.en), p6.en), p7.en), p8.en), p9.en), p10.en), p11.en), p12.en), p13.en), p14.en), p15.en), p16.en) }, ru: { translation: merge(merge(merge(merge(merge(merge(merge(merge(merge(merge(merge(merge(merge(merge(merge(ru, p2.ru), p3.ru), p4.ru), p5.ru), p6.ru), p7.ru), p8.ru), p9.ru), p10.ru), p11.ru), p12.ru), p13.ru), p14.ru), p15.ru), p16.ru) } },
    supportedLngs: ["en", "ru"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    fallbackLng: "en",
    detection: { order: ["localStorage", "navigator"], lookupLocalStorage: "valeriia_lang", caches: [] },
    interpolation: { escapeValue: false },
    parseMissingKeyHandler: (key) => (key.startsWith("err.") ? i18n.t("err.unknown") : key),
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng?.startsWith("ru") ? "ru" : "en";
});
document.documentElement.lang = i18n.language?.startsWith("ru") ? "ru" : "en";

export default i18n;
